import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { fontCondensedNormal } from "@tvg/atomic-ui/_static/Typography";
import CustomKeyboard from "@tvg/atomic-ui/_molecule/CustomKeyboard";
import ModalV2 from "@tvg/atomic-ui/_templates/ModalV2";
import { getBalanceIsShown } from "@tvg/sh-lib-preferences/redux/selectors";
import { Button } from "@tvg/design-system";
import { computeBalanceToDisplay } from "@tvg/wallet/src/utils";
import { getBalance } from "@urp/store-selectors";
import InputValue from "./InputValue";
import {
  Container,
  Main,
  ValueContainer,
  ButtonContainer
} from "./styled-components";
import { getCustomAmountMessages } from "../../../../store/selectors";
import { ButtonDescription, CustomModalProps } from "./types";
import {
  onAddPeriod,
  onChangeValue,
  submitCustomAmount,
  onClearValue
} from "./utils";

const CustomAmountModal = ({
  isOpen,
  toggleCustomAmountModal,
  setCustomAmount,
  onSelectAmount
}: CustomModalProps) => {
  const { title, buttons } = useSelector(getCustomAmountMessages);
  const userBalance: number = useSelector(getBalance);
  const balanceIsShown = useSelector(getBalanceIsShown);
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue("");
  }, [isOpen]);

  const subtitle = computeBalanceToDisplay(userBalance, balanceIsShown);

  return (
    <>
      <ModalV2
        isOpen={isOpen}
        title={title}
        subtitle={subtitle}
        subtitleFontFamily={fontCondensedNormal}
        onClose={() => toggleCustomAmountModal(!isOpen)}
        onOverlayClick={() => toggleCustomAmountModal(!isOpen)}
        qaLabel="custom-amount-modal"
        animation="fade"
        offsetLeft={12}
        offsetRight={12}
        fixedWidth="375px"
        isFullWidth={false}
        offsetTop={55}
        isFullHeight={false}
        hasRoundedCorners
        isTitleCapitalized={false}
        isTitleCenter
        useModalHeaderV3
      >
        {() => (
          <Container>
            <Main>
              <ValueContainer>
                <InputValue
                  value={value}
                  isLoading={false}
                  showAmountWarning={`${Math.floor(+value)}`.length > 6}
                  onChangeValue={onChangeValue(setValue, value, "input")}
                  hasFocus
                />
              </ValueContainer>
              <CustomKeyboard
                className="custom-keyboard"
                showPeriod
                showMoneyPills={false}
                onDelete={onClearValue(setValue)}
                onPeriod={onAddPeriod(value, setValue)}
                onChangeValue={onChangeValue(setValue, value, "keyboard")}
              />
              <ButtonContainer>
                {buttons.map((button: ButtonDescription) => (
                  <Button
                    key={button.action}
                    isStretched
                    variant={button.variant}
                    onPress={() =>
                      button.action === "submit"
                        ? submitCustomAmount(
                            value,
                            setCustomAmount,
                            toggleCustomAmountModal,
                            onSelectAmount
                          )
                        : toggleCustomAmountModal(false)
                    }
                    isDisabled={
                      button.action === "submit"
                        ? `${Math.floor(+value)}`.length > 6
                        : false
                    }
                    qaLabel={`custom-amount-${button.action}-button`}
                  >
                    {button.text}
                  </Button>
                ))}
              </ButtonContainer>
            </Main>
          </Container>
        )}
      </ModalV2>
    </>
  );
};

export default CustomAmountModal;
